import { render } from "./PenaltyBlockManagerComponent.vue?vue&type=template&id=3f86a82f&scoped=true&ts=true"
import script from "./PenaltyBlockManagerComponent.vue?vue&type=script&lang=ts"
export * from "./PenaltyBlockManagerComponent.vue?vue&type=script&lang=ts"

import "./PenaltyBlockManagerComponent.vue?vue&type=style&index=0&id=3f86a82f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f86a82f"]])

export default __exports__